/** @jsxImportSource @emotion/react */
import { CircularProgress as MUICircularProgress } from '@mui/material';
import { useTheme } from '../../ThemeProvider';

export interface Props {
  value: number;
  size?: number;
}

export const CircularProgress = ({ value, size }: Props) => {
  const { spacing, palette } = useTheme();
  const actualSize = size ? size : spacing.xs;
  return (
    <div css={{ position: 'relative' }}>
      <MUICircularProgress
        variant="determinate"
        value={100}
        thickness={7}
        size={actualSize}
        css={{
          color: palette.grey.x100,
          position: 'absolute',
          inset: 0,
        }}
      />
      <MUICircularProgress
        variant="determinate"
        value={value}
        thickness={7}
        size={actualSize}
      />
    </div>
  );
};
